import { render, staticRenderFns } from "./inbounds.vue?vue&type=template&id=baf376ca&scoped=true&"
import script from "./inbounds.vue?vue&type=script&lang=js&"
export * from "./inbounds.vue?vue&type=script&lang=js&"
import style0 from "./inbounds.vue?vue&type=style&index=0&id=baf376ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf376ca",
  null
  
)

export default component.exports